import React from 'react';
import { Reveal } from './Reveal';
type ModuleItem = {
  dot: string;
  number: string;
  title: string;
  description: string;
  tags: string[];
};
const modules: ModuleItem[] = [{
  dot: 'bg-green-500',
  number: 'MODULE 01',
  title: 'Architecture et Structure du Suivi',
  description: 'Programme complet avec le modèle "Dépistage-Intervention-Consolidation-Évaluation". Arrêtez de perdre 40% de votre temps de préparation.',
  tags: ['Bilan Initial', "Phase d'Intervention", 'Phase de Consolidation', 'Planificateur Hebdomadaire']
}, {
  dot: 'bg-yellow-400',
  number: 'MODULE 02',
  title: "32 Semaines d'Intervention Complète",
  description: "Structures d'intervention prêtes à utiliser pour toute l'année clinique.",
  tags: ['Logique de séance 45 minutes', 'Fondamentaux haute répétition', 'Flux thérapeutique']
}, {
  dot: 'bg-blue-500',
  number: 'MODULE 03',
  title: "Maîtrise des Fonctions Exécutives et de l'Attention",
  description: "Développement structuré de l'attention, des fonctions exécutives et construction de stratégies cognitives plus efficaces.",
  tags: ['Rythme cognitif', 'Sélection des activités', 'Exercices de transfert']
}, {
  dot: 'bg-red-500',
  number: 'MODULE 04',
  title: 'Plan Langage, Lecture et Conscience Phonologique',
  description: "Réception des difficultés, systèmes de décodage et organisation thérapeutique de l'équipe.",
  tags: ['Conscience phonémique', 'Décodage syllabique', 'Systèmes niveau intermédiaire-avancé']
}, {
  dot: 'bg-purple-500',
  number: 'MODULE 05',
  title: 'Cadres de Développement des Compétences',
  description: 'Systèmes maîtres pour évaluer, intervenir, corriger et progresser par domaine cognitif.',
  tags: ['Conseils techniques', 'Correction des erreurs communes', "Banques d'activités"]
}, {
  dot: 'bg-orange-500',
  number: 'MODULE 06',
  title: 'Leadership et Préparation de la Séance',
  description: 'Stratégies de communication parents-école, fiches de suivi, culture de cabinet professionnel.',
  tags: ['Préparation séance', 'Scripts de communication', 'Stratégie de bilan final']
}];
export function Modules() {
  return <section className="w-full bg-ink-soft px-4 py-20" data-id="element-144">
      <div className="mx-auto max-w-6xl" data-id="element-145">
        <Reveal data-id="element-146">
          <h2 className="text-center font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-147">
            Dans le Volume Principal : 6 Modules Cliniques Complets
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-148">
          {modules.map((m, i) => <Reveal key={m.number} delay={i % 3 * 0.08} data-id="element-149">
              <article className="flex h-full flex-col rounded-2xl border border-ink-border bg-ink-card p-6 transition-colors duration-200 hover:border-gold/50" data-id="element-150">
                <div className="flex items-center gap-2.5" data-id="element-151">
                  <span className={`h-3 w-3 rounded-full ${m.dot}`} data-id="element-152" />
                  <span className="text-xs font-bold uppercase tracking-widest text-white/50" data-id="element-153">
                    {m.number}
                  </span>
                </div>
                <h3 className="mt-4 text-lg font-extrabold leading-snug text-white" data-id="element-154">
                  {m.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-white/60" data-id="element-155">
                  {m.description}
                </p>
                <ul className="mt-5 flex flex-wrap gap-2" data-id="element-156">
                  {m.tags.map(t => <li key={t} className="rounded-full border border-ink-border bg-black/40 px-3 py-1 text-xs font-medium text-white/70" data-id="element-157">
                      {t}
                    </li>)}
                </ul>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}